'use strict';

import smoothscroll from 'smoothscroll-polyfill';

const scrollTop = {
    el: {
        html: document.documentElement,
        last: 0,
    },
    init: function () {
        // kick off the polyfill!
        smoothscroll.polyfill();

        var scrolltopBtn = document.querySelector('.scrollTop button');
        if(scrolltopBtn)
            scrolltopBtn.addEventListener('click', () => {
                window.scroll({top: 0, left: 0, behavior: 'smooth'});
                ga('send', 'event', 'backToTop', 'click', 'Button');
            });
    },

    display: function() {
        let scrollTopBtn = document.querySelector('.scrollTop');
        if( scrollTopBtn ) {
            if( window.scrollY < 300 ) {
                scrollTopBtn.classList.remove('show');
            } else {
                scrollTopBtn.classList.add('show');
            }
        }
    },
};

export default scrollTop;


// WEBPACK FOOTER //
// ./src/scripts/components/scrollTop.js